<label class="ui-g-5 field-label text-right-align fix-label-position" [ngClass]="{ required: isRequired }">
  {{ label }}
</label>
<div class="control-wrapper">
  <div>
    <input type="text" pInputText (change)="selectValue($event)" [value]="selectedValue" [disabled]="control.disabled || forceDisable" />
    <app-errors [errors]="errors" [showErrors]="!control.pristine && !control.disabled"></app-errors>
  </div>
</div>
